module.exports = __webpack_public_path__ + "img/search-followup.40afa1e4.png";